const formatItemId = (num) => {
    return String(num).padStart(4, "0");
};

const generateItemId = () => {
  const random = Math.floor(Math.random() * 9999) + 1;
  return "ITM" + formatItemId(random);
};

export const get_Item_Id = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;

    let itemId;
    let isUnique = false;

    while (!isUnique) {
        itemId = generateItemId();

        try {
            const response = await fetch(`${apiUrl}validation/validate_item_id.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ itemId }),
            });

            const data = await response.json();
            isUnique = data.unique;

        } catch (error) {
            console.error('Error validating item ID:', error);
            break;
        }
    }

    return itemId;
};
